$(function(){



	//--- Fix - Transitions Only After Page Load -------------
	$("body").removeClass("preload-transitions");

	//--- Fade-in アニメーション -------------
	var fadeInItems = $(".fade-in");
	$(document).on("scroll", function () {
		var pageTop = $(document).scrollTop();
		var fadeInThreshold = pageTop + ($(window).height() * 0.75);
		for (var i = 0; i < fadeInItems.length; i++) {
			var fadeInItem = fadeInItems[i];
			if ($(fadeInItem).offset().top < fadeInThreshold) {
				$(fadeInItem).addClass("is-visible");
			}
		}
	})

	//-------Hide/show PC header on scroll-------
	var lastScroll = 0;
	var headerToggle = true;
	var topScroll = false;
	$(window).on('scroll', function() {
		if($("body").hasClass("top-page")||$("body").hasClass("kv-slider-page"))
		{
			var y_scroll_pos = window.pageYOffset;
/*
			if(topScroll == false && y_scroll_pos > 0)
			{
				topScroll = true;
				var position = $("#our-story").offset().top;
				
				if(window.matchMedia('screen and (max-width:1023px)').matches)
				{
					 position = $("#kv__info").offset().top;
				}					
				$("html, body").animate({scrollTop:position}, 500, "linear");			
			}
*/
			if(window.matchMedia('screen and (min-width:1024px)').matches)
			{
				
/*
				if(topScroll == false && y_scroll_pos > 0)
				{
					topScroll = true;
					var position = $("#our-story").offset().top;				
					$("html, body").animate({scrollTop:position}, 500, "swing");	
				}
*/
				
				if(y_scroll_pos>lastScroll && headerToggle==true && y_scroll_pos>50){
					$("#header").addClass('hidden');
					headerToggle = false;
				}
				else if(y_scroll_pos==0){
					$("#header").addClass('hidden');
					headerToggle = false;
					topScroll = false;
				}
				else if(y_scroll_pos<lastScroll && headerToggle==false){
					console.log(y_scroll_pos);
					$("#header").removeClass('hidden');
					headerToggle = true;
				}
			}
			else
			{
				if(y_scroll_pos>50){
					$("#sp-home-btn,#sp-menu-open").addClass("show");
				}
				else if(y_scroll_pos==0){
					$("#sp-home-btn,#sp-menu-open").removeClass("show");
					topScroll = false;
				}
			}
		}
		else
		{
			var y_scroll_pos = window.pageYOffset;
			if(y_scroll_pos>lastScroll && headerToggle==true && y_scroll_pos>50){
				$("#header").addClass('hidden');
				headerToggle = false;
			}
			else if(y_scroll_pos<lastScroll && headerToggle==false){
				$("#header").removeClass('hidden');
				headerToggle = true;
			}
		}
		
		lastScroll = y_scroll_pos;
	});

	//-------Show PC header on hover on pagetop-------
	$("#header-hover-zone").mouseover(function(){
  		$("#header").removeClass('hidden');
		headerToggle = true;
	});

	//--- SP Menu toggle -------------
	//Open modal menu
	$("#sp-menu-open").click(function(){
		$(this).fadeOut();
		$("#sp-menu-container").addClass("visible");
		$("#sp-home-btn").addClass("no-bg");
		return false;
	});

	//Close modal menu
	$("#sp-menu-close").click(function(){
		$("#sp-menu-open").fadeIn();
		$("#sp-menu-container").removeClass("visible");
		$("#sp-home-btn").removeClass("no-bg");
		return false;
	});

	//--- In-page link smooth scrolling -------------
	$('a[href^="#"]').click(function(){
		var speed = 500;
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
		$("html, body").animate({scrollTop:position}, speed, "swing");
		return false;
	});
	

});